export default __webpack_public_path__ + "static/media/search-4-dark.dce75f9c.svg";